<template>
  <div id="contenedor-main-estimaciones-reportes-control-estimaciones">
    <!-- Generales -->
    <div
      class="white mb-5">
      <v-row
        justify="space-between">
        <v-col
          cols="6">
          <h3>CONTRATO</h3>
          {{ contrato.meta }}
        </v-col>
        <v-col
          cols="5">
          <v-row>
            <v-col
              cols="6">
              <v-row
                no-gutters>
                <v-col
                  cols="12"
                  class="font-weight-bold">
                  ESTIMACIÓN No.
                </v-col>
                <v-col
                  cols="12">
                  {{ estimacion.numero }}
                  <template
                    v-if="estimacion.esEstimacionFiniquito">
                    FINIQUITO
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="6">
              <v-row
                no-gutters>
                <v-col
                  cols="12"
                  class="font-weight-bold">
                  POR OBRA EFECTUADA EN EL PERIODO DE:
                </v-col>
                <v-col
                  cols="12"
                  class="text-uppercase">
                  {{ new Date(`${estimacion.fechaDel} 00:00:0`)
                    .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
                    AL
                  {{ new Date(`${estimacion.fechaAl} 00:00:0`)
                    .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
                </v-col>
              </v-row>
              <v-row
                no-gutters>
                <v-col
                  cols="6">
                  <span class="font-weight-bold text-uppercase">
                    Fecha presentación
                  </span>
                </v-col>
                <v-col
                  cols="6">
                  <span class="font-weight-bold text-uppercase">
                    Fecha autorización
                  </span>
                </v-col>
                <v-col
                  cols="6">
                  {{ new Date(`${estimacion.fechaPresentacion} 00:00:0`).toLocaleDateString() }}
                </v-col>
                <v-col
                  cols="6">
                  {{ new Date(`${estimacion.fechaAutorizacion} 00:00:0`).toLocaleDateString() }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <!-- Datos del contrato -->
    <div class="white rounded-xl mb-5">
      <v-row>
        <v-col
          cols="12">
          <v-card
            tile
            outlined
            class="text-center base4">
            DATOS DE CONTRATACIÓN
          </v-card>
          <v-row
            justify="space-between"
            align="start"
            class="text-center">
            <v-col
              cols="3">
              <span class="font-weight-bold">
                NÚM. CONTRATO
              </span>
              <v-row
                no-gutters>
                <v-col
                  cols="12">
                  {{ contrato.numero }}
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="3">
              <span class="font-weight-bold">
                FECHA
              </span>
              <v-row
                no-gutters>
                <v-col
                  cols="12">
                  {{ new Date(contrato.fecha).toLocaleDateString() }}
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="3">
              <span class="font-weight-bold">
                IMPORTE TOTAL
              </span>
              <v-row
                no-gutters>
                <v-col
                  cols="12">
                  {{ contrato.importeTotal | currency }}
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="3">
              <span class="font-weight-bold">
                ANTICIPO
              </span>
              <v-row
                no-gutters>
                <v-col
                  cols="12">
                  {{ contratoTotalAnticipo | currency }}
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="3">
              <span class="font-weight-bold">
                FECHAS
              </span>
              <v-row
                no-gutters>
                <v-col>
                  <span class="font-weight-bold">
                    FECHA INICIO
                  </span>
                  <v-row
                    no-gutters>
                    <v-col
                      cols="12">
                      {{ new Date(estimacion.fechaInicioContrato).toLocaleDateString() }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <span class="font-weight-bold">
                    FECHA TERMINO
                  </span>
                  <v-row
                    no-gutters>
                    <v-col
                      cols="12">
                      {{ new Date(estimacion.fechaTerminoContrato).toLocaleDateString() }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="3">
              <span class="font-weight-bold">
                TIPO DE INVERSIÓN
              </span>
              <v-row
                no-gutters>
                <v-col
                  cols="12">
                  {{ getTipoInversion }}
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="3">
              <span class="font-weight-bold">
                AVANCES
              </span>
              <v-row
                no-gutters>
                <v-col>
                  <span class="font-weight-bold">
                    AV. FISICO
                  </span>
                  <v-row
                    no-gutters>
                    <v-col
                      cols="12">
                      {{ getAvanceFisico }}%
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <span class="font-weight-bold">
                    AV. FINANCIERO
                  </span>
                  <v-row
                    no-gutters>
                    <v-col
                      cols="12">
                      {{ getPorcentajeAvanceFinanciero }}%
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div class="white rounded-xl">
      <v-row justify="space-between">
        <v-col
          cols="4"
          md="3">
          <v-list
            dense
            subheader
            class="mb-3">
            <v-subheader>
              ESTADO DE CUENTA ANTICIPO
            </v-subheader>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  ESTA ESTIMACION
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ estimacion.importeAmortizacionAnticipo | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  ACUMULADO ANTERIOR
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ amortizacionAnticipoAcumuladoAnteriror | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  ACUMULADO TOTAL
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ amortizacionAnticipoAcumuladoTotal | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  ANTICIPO PAGADO
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ contratoTotalAnticipo | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  SALDO ANTICIPO
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ amortizacionAnticipoSaldo | currency }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <!-- amortizacion anticipo financiado -->
          <v-list
            v-if="contrato.esObraFinanciada"
            dense
            subheader
            class="text-uppercase">
            <v-subheader>
            </v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Costo Financiamiento del Anticipo
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ contratoTotalAnticipoFinanciado | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Amortizacion acumulada antes de esta estimacion
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ importeAmortizacionAnticipoFinanciado | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Amortizacion esta estimacion
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ estimacion.importeCostoFinancieroAmortizacionAnticipo | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Suma Amortizaciones
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ sumaAmortizacionAnticipoFinanciado | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Saldo CF del Anticipo
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ saldoAmortizacionAnticipoFinanciado | currency }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col
          cols="4"
          md="4">
          <estimacion-liquidacion
            :estimacion="estimacion"
            :esObraFinanciada="contrato.esObraFinanciada"
            mostrar-detalles-deducciones
            mostrar-detalles-control-estimacion>
          </estimacion-liquidacion>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col
          cols="4"
          md="3">
          <v-list
            dense
            subheader>
            <v-subheader>
              ESTADO CUENTA DE OBRA
            </v-subheader>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  ESTA ESTIMACION
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ estimacion.importeEstimado | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  ACUMULADO ANTERIOR
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ estimadoAcumuladoAnteriror | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  ACUMULADO TOTAL
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ acumuladoTotal | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  MONTO CONTRATO
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ importeDelContrato | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              link>
              <v-list-item-content>
                <v-list-item-title>
                  SALDO DE CONTRATO
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ saldoContrato | currency }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </div>
    <!-- Firmas -->
    <div
      class="mt-3">
      <v-row
        justify="space-between">
        <v-col
          cols="3">
          <v-row
            justify="center"
            align="center">
            <h3>
              FORMULO
            </h3>
          </v-row>
          <v-row>
            <v-col
              cols="12">
              <firma
                :nombre="contrato.contratista.nombreRepresentante"
                :sub-nombre="contrato.contratista.nombreRazonSocial">
              </firma>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="8">
          <v-row
            justify="center"
            align="center">
            <h3>REVISO</h3>
          </v-row>
          <v-row
            justify="center">
            <v-col
              v-if="getContratoSupervisionExterna"
              cols="4">
              <firma
                :nombre="getContratoSupervisionExterna
                  .contratoRelacionado.contratista.nombreRazonSocial"
                sub-nombre="Supervisión externa"
                key="supervisionExterna">
              </firma>
            </v-col>
            <v-col
              cols="4">
              <firma
                v-if="getSupervisor"
                :nombre="getSupervisor.funcionario.nombre"
                sub-nombre="supervisor de obra"
                key="contratista">
              </firma>
            </v-col>
            <template
              v-for="firma in getFirmasActualizadas">
              <template>
                <v-col
                  cols="4"
                  :key="firma.id">
                  <firma
                    :sub-nombre="firma.funcionario.puesto"
                    :nombre="firma.funcionario.nombre">
                  </firma>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import EstimacionLiquidacion from '@/components/administracion/ejecucion/estimaciones/reportes/Liquidacion.vue';
import Firma from '@/components/Firma.vue';
import mixDescargaControlEstimaciones from './mixDescargaControlEstimaciones';

export default {
  name: 'MainEstimacionesReporteControlEstimaciones',
  components: {
    EstimacionLiquidacion,
    Firma,
  },
  mixins: [
    mixDescargaControlEstimaciones],
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    estimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    getFirmasActualizadas() {
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, this.firmas);
      return encabezadoReferencia.firmas;
    },
  },
  /*
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdf() {
      this.$emit('generando');
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const supervisor = this.getSupervisor || '';
      const firmasFuncionarios = this.firmas;
      const datosCalculados = {
        contratoTotalAnticipo: this.contratoTotalAnticipo,
        contratoAvanceFisico: this.getAvanceFisico,
        contratoAvanceFinanciero: this.mixAvanceFinancieroALaFecha(this.estimacion.fechaAl).avance,
        amortizacionAnticipoAcumuladoAnteriror: this.amortizacionAnticipoAcumuladoAnteriror,
        amortizacionAnticipoAcumuladoTotal: this.amortizacionAnticipoAcumuladoTotal,
        amortizacionAnticipoSaldo: this.amortizacionAnticipoSaldo,
        estimadoAcumuladoAnteriror: this.estimadoAcumuladoAnteriror,
        acumuladoTotal: this.acumuladoTotal,
        saldoContrato: this.saldoContrato,
        contratoTotalAnticipoFinanciado: this.contratoTotalAnticipoFinanciado,
        importeAmortizacionAnticipoFinanciado: this.importeAmortizacionAnticipoFinanciado,
        sumaAmortizacionAnticipoFinanciado: this.sumaAmortizacionAnticipoFinanciado,
        saldoAmortizacionAnticipoFinanciado: this.saldoAmortizacionAnticipoFinanciado,
        importeContrato: this.importeDelContrato,
        programaInversion: this.getPrograma,
        supervisionExterna: this.getContratoSupervisionExterna?.contratoRelacionado
          ?.contratista?.nombreRazonSocial || '',
      };
      const datos = this.formatoObjeto(datosCalculados);
      const conveniosConFormato = this.formatoObjeto(this.getContratoConvenios);

      let nombreTemplate = 'templateControlEstimacion';
      if (this.contrato.esObraFinanciada) { nombreTemplate = 'templateControlEstimacionOPF'; }

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          convenios: conveniosConFormato,
          estimacion: estimacionConFormato,
          supervisor,
          firmas: firmasFuncionarios,
          datos,
          footer: '',
        },
      }, `${this.contrato.numero}_Control_Estimacion_${this.estimacion.numero}`);
      this.generandoPdfControlEstimaciones = false;
      this.$emit('terminando');
    },

  },
  computed: {

    importeDelContrato() {
      return this.estimacion.importeContratoSinFinanciamiento;
    },
    numeroEstimacion() {
      return Number(this.estimacion.numero);
    },
    contratoTotalAnticipo() {
      return this.estimacion.importeAnticipo;
    },
    contratoTotalAnticipoFinanciado() {
      return this.estimacion.importeAnticipoFinanciamiento;
    },
    estimacionesAnteriores() {
      return this.estimaciones
        .filter(({ numero }) => Number(numero) < this.numeroEstimacion);
    },
    amortizacionAnticipoAcumuladoAnteriror() {
      return this.$ObjSumar(this.estimacionesAnteriores, 'importeAmortizacionAnticipo');
    },
    importeAmortizacionAnticipoFinanciado() {
      return this.$ObjSumar(this.estimacionesAnteriores,
      'importeCostoFinancieroAmortizacionAnticipo');
    },
    sumaAmortizacionAnticipoFinanciado() {
      return (this.importeAmortizacionAnticipoFinanciado
      + this.estimacion.importeCostoFinancieroAmortizacionAnticipo);
    },
    amortizacionAnticipoAcumuladoTotal() {
      return (
        this.amortizacionAnticipoAcumuladoAnteriror
        + this.estimacion.importeAmortizacionAnticipo);
    },
    amortizacionAnticipoSaldo() {
      return (this.contratoTotalAnticipo - this.amortizacionAnticipoAcumuladoTotal);
    },
    saldoAmortizacionAnticipoFinanciado() {
      return (this.contratoTotalAnticipoFinanciado - this.sumaAmortizacionAnticipoFinanciado);
    },
    estimadoAcumuladoAnteriror() {
      return this.$ObjSumar(this.estimacionesAnteriores, 'importeEstimado');
    },
    acumuladoTotal() {
      return (this.estimacion.importeEstimado + this.estimadoAcumuladoAnteriror);
    },
    saldoContrato() {
      return (this.importeDelContrato - this.acumuladoTotal);
    },
    ordenarListadoFirmas() {
      if (!this.firmas) return [];
      return this.firmas.slice().sort((a, b) => a.orden - b.orden);
    },
    getSupervisor() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoConvenios() {
      if (!this.contrato.convenios) return [];
      const conveniosPlazo = this.contrato.convenios
        .filter((c) => c.tipo === 'PLAZO')
        .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
      const conveniosResto = this.contrato.convenios
        .filter((c) => c.tipo !== 'PLAZO');
      return ([conveniosPlazo[0], ...conveniosResto]
        .sort((a, b) => new Date(`${a.fecha} 00:00:0`) - new Date(`${b.fecha} 00:00:0`)));
    },
    getContratoSupervisionExterna() {
      if (this.contrato.contratosRelacionados.length <= 0) return null;
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
    getPrograma() {
      if (this.contrato.obras.length <= 0) return 'MUNICIPAL';
      if (!this.contrato.obras[0].obra.programa) return 'MUNICIPAL';
      return this.contrato.obras[0].obra.programa.nombre;
    },
    getAvanceFisico() {
      if (this.estimacion.esEstimacionFiniquito) return 100;
      return this.mixAvanceFinancieroALaFecha(this.estimacion.fechaAl).avance;
    },

  }, */
};
</script>

<style lang="scss" scoped>
.altura-firmas {
  min-height: 100px
}
@media print {
  @page {
    size: landscape;
    margin: 0;
  }
}
</style>
